import { ReactNode } from 'react'
import { useWarnBrowseAway } from './useWarnBrowseAway'

interface WarnGoBackProps {
  children: ReactNode
  isDirty: boolean
}

export const WarnBrowseAway = ({ children, isDirty }: WarnGoBackProps) => {
  useWarnBrowseAway({ isDirty })

  return <>{children}</>
}
